module.exports = __webpack_public_path__ + "img/40.2.TN.bdcd6ff9.png";